class DisplayPlugin {
	static install(Vue, options) {
		window.$display = DisplayPlugin.displayFabric();
		Vue.prototype.$display = Vue.observable(window.$display);
		window.addEventListener('resize', () => {
			window.$display.clientWidth =  document.body.clientWidth;
			window.$display.clientHeight =  document.body.clientHeight;
		});
	}
	static displayFabric(){
		return {
			clientWidth: document.body.clientWidth,
			clientHeight: document.body.clientHeight
		};
	}
}

export default DisplayPlugin;